var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.filters),function(filter,index){return [(filter.filterLabel)?_c('b-tag',{key:index,staticClass:"mr-2",attrs:{"variant":"secondary"},on:{"remove":function($event){return _vm.$emit('remove', index)}}},[_vm._v(_vm._s(filter.filterLabel))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }